import { useQuery } from "@tanstack/react-query";

import apiClient from "@/lib/api/client";

export function useCreateUserResolveProducts() {
  return useQuery({
    queryFn: async () =>
      apiClient
        .url("/users/create/resolve-products")
        .get()
        .json<{ id: number; title: string }[]>(),
    queryKey: ["create-user-resolve-products"],
  });
}
